export const COMPANY_BRANDS_LIMIT = 50;
